import { Injectable } from '@angular/core';
import { UserCredentials, Configuration } from '../models';
import { AccountService } from '../services/account.service';
import { AppConfig } from '../services/app.config';

@Injectable()
export class BaseDataService {

  protected Config: Configuration;
  protected userCredentials = new UserCredentials();

  constructor(protected accountService: AccountService) {
    this.Config = AppConfig.config;

    this.accountService.getCredentialsPromise().then(userPromise => {
      this.userCredentials = userPromise;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/abstract/base-data.service.ts